// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { all, fork } from 'redux-saga/effects';
import { deleteDatastoreFilesSaga } from './DeleteDatastoreFiles';
import { fetchAllWorkspaceFilesSaga } from './FetchAllWorkspaceFiles';
import { pollDatastoreRunnerStatusSaga } from './PollDatastoreRunnerStatus';
import { startDatastoreRunnerSaga } from './StartDatastoreRunner';
import { uploadDatastoreFilesSaga } from './UploadDatastoreFiles';

export default function* datastoreSaga() {
  yield all([
    fork(fetchAllWorkspaceFilesSaga),
    fork(pollDatastoreRunnerStatusSaga),
    fork(startDatastoreRunnerSaga),
    fork(deleteDatastoreFilesSaga),
    fork(uploadDatastoreFilesSaga),
  ]);
}
